import Vue from 'vue'

var pipeService = new Vue({
    data: {
        CONTROLPANEL2STORYVIEW: 'controlpanel_2_storyview',
        SEEKFROMTIME: 'seek_from_time',
        STORYVIEW2DETAILVIEW: "storyview_2_detailview",
        DETAILVIEW2HUMORQUERY: "detailview_2_humorquery",
        PROJVIEW2STORYVIEW: "porjview_2_storyview",
        LOCATESENTENCE: 'locate_sentence',
        PUNCHLINEQUERY: 'punchline_query',
        SPEECHDATAPOST: "speech_data_post",
        SUBMITFILTER: "submit_filter",
        ADJUSTTHRESHOLDS: "adjust_thresholds",
        SELECTVIDEO: "select_video",
    },
    methods: {
        // control panel to story view
        // emit/on
        emitControlpanel2Storyview: function(msg) {
            this.$emit(this.CONTROLPANEL2STORYVIEW, msg);
        },
        onControlpanel2Storyview: function(callback) {
            this.$on(this.CONTROLPANEL2STORYVIEW, function(msg) {
                callback(msg);
            });
        },
        emitSelectVideo: function(msg) {
            this.$emit(this.SELECTVIDEO, msg);
        },
        onSelectVideo: function(callback) {
            this.$on(this.SELECTVIDEO, function(msg) {
                callback(msg);
            });
        },
        // video playing
        emitSeekFromTime: function(msg) {
            this.$emit(this.SEEKFROMTIME, msg);
        },
        onSeekFromTime: function(callback) {
            this.$on(this.SEEKFROMTIME, function(msg) {
                callback(msg);
            });
        },
        // punchline query
        emitDetailview2Humorquery: function(msg) {
            this.$emit(this.DETAILVIEW2HUMORQUERY, msg);
        },
        onDetailview2Humorquery: function(callback) {
            this.$on(this.DETAILVIEW2HUMORQUERY, function(msg) {
                callback(msg);
            });
        },
        // storyview 2 detailview
        emitStoryview2Detailview: function(msg) {
            this.$emit(this.STORYVIEW2DETAILVIEW, msg);
        },
        onStoryview2Detailview: function(callback) {
            this.$on(this.STORYVIEW2DETAILVIEW, function(msg) {
                callback(msg);
            });
        },
        // detailview 2 humorquery
        emitPunchlineQuery: function(msg) {
            this.$emit(this.PUNCHLINEQUERY, msg);
        },
        onPunchlineQuery: function(callback) {
            this.$on(this.PUNCHLINEQUERY, function(msg) {
                callback(msg);
            });
        },
        // projview 2 storyview
        emitProjview2Storyview: function(msg) {
            this.$emit(this.PROJVIEW2STORYVIEW, msg);
        },
        onProjview2Storyview: function(callback) {
            this.$on(this.PROJVIEW2STORYVIEW, function(msg) {
                callback(msg);
            });
        },
        emitLocateSentence: function(msg) {
            this.$emit(this.LOCATESENTENCE, msg);
        },
        onLocateSentence: function(callback) {
            this.$on(this.LOCATESENTENCE, function(msg) {
                callback(msg);
            });
        },
        // ---explorationview speech data post
        emitSpeechData: function(msg) {
            this.$emit(this.SPEECHDATAPOST, msg);
        },
        onSpeechData: function(callback) {
            this.$on(this.SPEECHDATAPOST, function(msg) {
                callback(msg);
            });
        },
        // ---submit filter
        emitSubmitFilter: function(msg) {
            this.$emit(this.SUBMITFILTER, msg);
        },
        onSubmitFilter: function(callback) {
            this.$on(this.SUBMITFILTER, function(msg) {
                callback(msg);
            });
        },
        // --- adjust feature thresholds
        emitFeatureThresholds: function(msg){
            this.$emit(this.ADJUSTTHRESHOLDS, msg);
        },
        onFeatureThresholds: function(callback){
            this.$on(this.ADJUSTTHRESHOLDS, function(msg){
                callback(msg);
            });
        }

    }
});

export default pipeService